
import React from "react";
import { IoClose } from "react-icons/io5";
import { MdWorkspacePremium } from "react-icons/md";
import "./ProModal.css"; // Import the CSS file for styling

interface ProModalProps {
    showProModal: boolean;
    onClose: () => void;
    onButtonClick: (buttonText: string) => void;
}

const ProModal: React.FC<ProModalProps> = ({ showProModal, onClose, onButtonClick }) => {
    if (!showProModal) return null;

    return (
        <div className="modal">
            <div className="pro-modal-content">

                <button className="modal-close-button" onClick={onClose}>
                    <IoClose size={18} />
                </button>
                <h2 className="modal-title">💎Upgrade to Premium</h2>
                {/* <p className="modal-description">
                    You’re getting a taste of Pro Plan features! Occasionally, we’ll unlock some for you to try for free - usually for a week.
                </p> */}
                <p className="modal-description">
                    Unlock these powerful tools permanently and supercharge your productivity!
                </p>
                <div className="modal-buttons">
                    <button className="modal-button" onClick={() => onButtonClick("Maybe - show me the Plans")}>
                        Maybe - show me the Plans
                    </button>
                    <button className="modal-button" onClick={() => onButtonClick("No thanks, I'm good")}>
                        No thanks, I'm good
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProModal;